
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/downloads/[download]",
      function () {
        return require("private-next-pages/mahashivratri/downloads/[download]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/downloads/[download]"])
      });
    }
  